import script from "./SearchTabPanels.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchTabPanels.vue?vue&type=script&setup=true&lang=ts"

import "./SearchTabPanels.vue?vue&type=style&index=0&id=4afdc65f&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4afdc65f"]])

export default __exports__